import React, { memo, useCallback } from 'react'
import { Modal, List } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'

interface ITemplate {
  id: number
  name: string
  file_name?: string
  message?: string
}

interface PrintTemplateSelectModalProps {
  isOpen: boolean
  templates: ITemplate[]
  onCancel: () => void
  onSelectTemplate: (template: ITemplate) => void
}

export const PrintTemplateSelectModal: React.FC<PrintTemplateSelectModalProps> = memo(props => {
  const { isOpen, templates, onCancel, onSelectTemplate } = props

  const handleTemplateSelect = useCallback(
    (template: ITemplate) => {
      onSelectTemplate(template)
      onCancel()
    },
    [onSelectTemplate, onCancel],
  )

  return (
    <Modal
      title="Выберите шаблон для печати"
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      destroyOnHidden={true}
      styles={{
        body: {
          maxHeight: '60vh',
          overflow: 'auto',
        },
      }}
    >
      <List
        dataSource={templates}
        renderItem={template => (
          <List.Item
            key={template.id}
            onClick={() => handleTemplateSelect(template)}
            style={{
              cursor: 'pointer',
              padding: '12px 16px',
              border: '1px solid #f0f0f0',
              borderRadius: '6px',
              marginBottom: '8px',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#f5f5f5'
              e.currentTarget.style.borderColor = '#d9d9d9'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent'
              e.currentTarget.style.borderColor = '#f0f0f0'
            }}
          >
            <List.Item.Meta
              avatar={<PrinterOutlined style={{ fontSize: '18px', color: '#1890ff' }} />}
              title={template.name}
              description={`Шаблон #${template.id}`}
            />
          </List.Item>
        )}
      />
    </Modal>
  )
})

PrintTemplateSelectModal.displayName = 'PrintTemplateSelectModal'
